export const searchOptions = [
	{ label: 'WSIN', value: 'wsin' },
	{ label: 'Product Title', value: 'name' }
];

export const defaultFilter = {
	searchOptionType: searchOptions[0].value,
	searchValue: ''
};
